import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { PRODUCTS, PRODUCT_ROUTES } from '../../../constants';
import style from './Event.module.scss';


export default function Event({
  eventId,
  eventName,
  updateRightSidebar,
  eventInRunning,
  widthSize,
  product = PRODUCTS.exchange,
}) {
  const productUrlPrefix = PRODUCT_ROUTES[product];

  const eventRowClass = classNames({
    [style.eventRow]: true,
    [style['eventRow--inPlay']]: eventInRunning
  });

  return (
    <div className={eventRowClass}>
      <Link
        className={style.eventName}
        to={`${productUrlPrefix}/events/${eventId}`}
        onClick={() => {
          if (widthSize < 1201) {
            updateRightSidebar({
              visible: false
            });
          }
        }}
      >
        {eventName}
      </Link>
    </div>
  );
}

Event.propTypes = {
  eventId: PropTypes.string.isRequired,
  eventName: PropTypes.string.isRequired,
  updateRightSidebar: PropTypes.func,
  widthSize: PropTypes.number,
  eventInRunning: PropTypes.bool,
  product: PropTypes.string,
};
